/* tslint:disable */
/* eslint-disable */
/**
 * CourierApi
 * CourierApi
 *
 * The version of the OpenAPI document: 2.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { PushSubscriptionKey } from './PushSubscriptionKey';
import {
    PushSubscriptionKeyFromJSON,
    PushSubscriptionKeyFromJSONTyped,
    PushSubscriptionKeyToJSON,
    PushSubscriptionKeyToJSONTyped,
} from './PushSubscriptionKey';

/**
 * 
 * @export
 * @interface PushSubscription
 */
export interface PushSubscription {
    /**
     * 
     * @type {string}
     * @memberof PushSubscription
     */
    endpoint: string;
    /**
     * 
     * @type {PushSubscriptionKey}
     * @memberof PushSubscription
     */
    keys: PushSubscriptionKey;
    /**
     * 
     * @type {number}
     * @memberof PushSubscription
     */
    id?: number;
    /**
     * 
     * @type {number}
     * @memberof PushSubscription
     */
    courierUserId?: number;
    /**
     * 
     * @type {number}
     * @memberof PushSubscription
     */
    courierId?: number;
}

/**
 * Check if a given object implements the PushSubscription interface.
 */
export function instanceOfPushSubscription(value: object): value is PushSubscription {
    if (!('endpoint' in value) || value['endpoint'] === undefined) return false;
    if (!('keys' in value) || value['keys'] === undefined) return false;
    return true;
}

export function PushSubscriptionFromJSON(json: any): PushSubscription {
    return PushSubscriptionFromJSONTyped(json, false);
}

export function PushSubscriptionFromJSONTyped(json: any, ignoreDiscriminator: boolean): PushSubscription {
    if (json == null) {
        return json;
    }
    return {
        
        'endpoint': json['endpoint'],
        'keys': PushSubscriptionKeyFromJSON(json['keys']),
        'id': json['id'] == null ? undefined : json['id'],
        'courierUserId': json['courierUserId'] == null ? undefined : json['courierUserId'],
        'courierId': json['courierId'] == null ? undefined : json['courierId'],
    };
}

export function PushSubscriptionToJSON(json: any): PushSubscription {
    return PushSubscriptionToJSONTyped(json, false);
}

export function PushSubscriptionToJSONTyped(value?: PushSubscription | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'endpoint': value['endpoint'],
        'keys': PushSubscriptionKeyToJSON(value['keys']),
        'id': value['id'],
        'courierUserId': value['courierUserId'],
        'courierId': value['courierId'],
    };
}

